
// src/web/components/diary-attachments.jsx

import React from 'react'
import ReactDOM from 'react-dom'
import { themr } from 'react-css-themr'
import classnames from 'classnames'
import diaryTheme from './themes/diary.css'
import connect from '../../connects/diary-attachments'
import {
  Button,
  IconButton,
} from 'react-toolbox/lib/button'
import {
  CardMedia,
  CardText,
} from 'react-toolbox/lib/card'
import AttachmentsTheme from './themes/attachments.css'
import _ from 'lodash'
import AttachmentFile from './attachment-file.jsx';
import VideoViewer from './video-viewer.jsx'
import ProgressBar from 'react-toolbox/lib/progress_bar'
import {
  FontIcon,
} from 'react-toolbox/lib/font_icon'

function isImageVideo(file) {
  return file.content_type.match(/^image/) || file.content_type.match(/^video|audio/) 
}

@themr('Diary', diaryTheme)
class DiaryAttachments extends React.Component {
  showImagesView = (image)=> {
    this.props.showImagesView(this.props.comment ? 'GROUP_COMMENT' : 'GROUP_TIMELINE', this.props.comment ? this.props.comment_id : this.props.diary_id, image)
  }

  showPrevImage = (images) => {
    if ( this.props.ui.imgIndex > 0 ) {
      const index = this.props.ui.imgIndex - 1
      this.props.updateUI({
        imgIndex: index,
        isVideo: !!images[index].content_type.match(/^video|audio/)
      })
    }
  }
  showNextImage = (images) => {
    if (images.length - 1 > this.props.ui.imgIndex) {
      const index = this.props.ui.imgIndex + 1
      this.props.updateUI({ 
        imgIndex: index,
        isVideo: !!images[index].content_type.match(/^video|audio/)
      })
    }
  }
  selectDots = (images, index) => {
    this.props.updateUI({
      imgIndex: index,
      isVideo : !!images[index].content_type.match(/^video|audio/)
    })
  }
  render() {
    const {
      t,
      ui,
      updateUI,
      diary_id,
      comment_id,
      files,
      theme,
      showAttachments,
      showImagesView,
      comment,
    } = this.props

    const images = _.filter(files, (file)=> isImageVideo(file))
    const otherfiles = _.filter(files, (file)=> !isImageVideo(file))

    const left_btn = ui && ui.imgIndex == 0 ? true : false
    const right_btn = ui && ui.imgIndex + 1 == images.length ? true : false

    return (
      <div>
        {images.length > 0 && ui && images[ui.imgIndex] &&          
          <nav className={AttachmentsTheme.nav}>
            <div className={!comment ? AttachmentsTheme.navAttachmentsArea : AttachmentsTheme.navAttachmentsCommentArea}>
              <div className={AttachmentsTheme.navAttachmentsField}>
                {!images[ui.imgIndex].content_type.match(/^video|audio/) ? 
                  <div style={{height: 280, position: "relative"}}>
                    <img src={images[ui.imgIndex].file.url} className={AttachmentsTheme.navImage} style={{marginBottom: images.length > 1 ? 0 : 20}} onClick={() => this.showImagesView(images[ui.imgIndex])}/>
                  </div>:
                  images[ui.imgIndex].status == 'committed' ?
                  <VideoViewer video={images[ui.imgIndex]} t={t} parent_component={'TIMELINE_PAGE'}/>:
                  <div style={{height: 280, position: "relative"}}>
                    {images[ui.imgIndex].status == 'prepared' ?
                    <div style={{ position: 'absolute', top: 0, bottom: 0, right: 0, left: 0, margin: 'auto', width: '90%', height: '3.2rem'}}>
                        <ProgressBar type='circular' mode='indeterminate' multicolor/>
                        <p style={{ fontSize: 16 }}>{t('label:ファイルはまだ処理中')}</p>
                    </div>:
                    <div style={{ position: 'absolute', top: 0, bottom: 0, right: 0, left: 0, margin: 'auto', width: '90%', height: '3.2rem'}}>
                      <FontIcon value="close" style={{ fontSize: 40, color: 'red' }} />
                      <p style={{ fontSize: 16 }}>{t('label:ファイルが読み込めない')}</p>
                    </div>}
                  </div>}
                  {images.length > 1 && 
                  <div style={{display: 'flex' }}>
                    <div className={classnames(AttachmentsTheme.navArea, AttachmentsTheme.navPrev)} onClick={() => this.showPrevImage(images)}>
                      <IconButton icon='keyboard_arrow_left'  disabled={left_btn}/>
                    </div>
                      <ul className={AttachmentsTheme.navDots}>
                        {images.map((image, i) => 
                          <li key={i} style={{display: 'inline-block'}}>
                            <IconButton icon='circle' 
                              onClick={() => this.selectDots(images, i)}
                              className={ui.imgIndex == i ? AttachmentsTheme.navSelectDots : AttachmentsTheme.navNotSelectDots}/>
                          </li>
                        )}
                      </ul>
                    <div className={classnames(AttachmentsTheme.navArea, AttachmentsTheme.navNext)} onClick={() => this.showNextImage(images)}>
                      <IconButton icon='keyboard_arrow_right'  disabled={right_btn}/>
                    </div>
                  </div>}
              </div>
            </div>
          </nav>
        }
        {otherfiles.length > 0 &&
          <div style={{ marginLeft: 10 }}>
            {otherfiles.map((file)=> 
              <AttachmentFile key={file.file_id || file.video_id} t={t} file={file} showAttachments={showAttachments} diary_id={diary_id} comment_id={comment_id}  />
            )}
          </div>
        }
      </div>
    )
  }
}

export const RawDiaryAttachments = DiaryAttachments
export default connect(DiaryAttachments)



// WEBPACK FOOTER //
// ./src/web/components/diary-attachments.jsx